import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/button';
import { Link } from '@tanstack/react-router';
import { Plus, RefreshCw } from 'lucide-react';
import { KioskSettingsTable } from '../components/KioskSettingsTable';
import { mockKioskSettings } from '../data/mock-kiosk-data';

export function KioskSettingsListPage() {
  return (
    <>
      <PageHeader
        title="Kiosk Settings"
        description="Manage kiosk display settings profiles."
        actions={
          <>
            <Button variant="outline" size="sm">
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh
            </Button>
            <Button asChild size="sm">
              <Link to="/kiosk/settings/add">
                <Plus className="mr-2 h-4 w-4" />
                Add Settings
              </Link>
            </Button>
          </>
        }
      />
      
      <div className="space-y-4">
        <KioskSettingsTable data={mockKioskSettings} />
      </div>
    </>
  );
}

export default KioskSettingsListPage;
